import { createRootRoute } from '@tanstack/react-router'
import { AppLayout } from './shell'

export const rootRoute = createRootRoute({ component: AppLayout })
